var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1166 15.8832L8.7999 18.2082C8.64157 18.3748 8.64157 18.6332 8.7999 18.7998L11.1166 21.1248C11.3749 21.3915 11.8249 21.1998 11.8249 20.8332V19.3332H16.8332C17.2916 19.3332 17.6666 18.9582 17.6666 18.4998C17.6666 18.0415 17.2916 17.6665 16.8332 17.6665H11.8249V16.1748C11.8249 15.7998 11.3749 15.6165 11.1166 15.8832ZM23.2082 13.2082L20.8916 10.8832C20.6332 10.6165 20.1832 10.8082 20.1832 11.1748V12.6665H15.1666C14.7082 12.6665 14.3332 13.0415 14.3332 13.4998C14.3332 13.9582 14.7082 14.3332 15.1666 14.3332H20.1749V15.8248C20.1749 16.1998 20.6249 16.3832 20.8832 16.1165L23.1999 13.7915C23.3666 13.6332 23.3666 13.3665 23.2082 13.2082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.22641884737c36ffbfc37e26b23f04d9.svg";
export { ForwardRef as ReactComponent };